/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'ramda';

import { historyPropTypes } from 'types';
import { copyToClipBoard } from '#providers/clipBoardUtils';

import Biometric from './components/Biometric';
import {
  Container, Space, OrderLink, Icon,
} from './style';

const bookingBaseUrl = `${process.env.REACT_APP_BOOKING_BOB}biometric?`;
console.log('bookingBaseUrl: ', bookingBaseUrl);
export function TopContainer({
  bookingCode,
  history,
  orderId,
  biometric,
}) {
  const onOrderClick = () => {
    history.push(`/order/${orderId}`);
  };
  const biometricLinkHandler = (event) => {
    event.preventDefault();
    copyToClipBoard(`${bookingBaseUrl}biometric=${biometric._id}&token=${biometric.token}`);
  };
  return (
    <Container>
      {biometric
      && (
      <Biometric {...pick(['providerId', 'status'], biometric)} clickHandler={biometricLinkHandler} />)}
      <Space />
      <OrderLink onClick={onOrderClick}>
        <Icon />
        {`Order #${bookingCode}`}
      </OrderLink>
    </Container>
  );
}

TopContainer.propTypes = {
  bookingCode: PropTypes.string,
  orderId    : PropTypes.string,
  history    : historyPropTypes.isRequired,
  biometric  : PropTypes.shape({
    _id  : PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }),
};

TopContainer.defaultProps = {
  bookingCode: '',
  orderId    : '',
  biometric  : undefined,
};

export default TopContainer;
